// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PositionedItemsContainer{
    position: relative;
    width: 100%;
    height: 100%;
}

.PositionedItemsContainer_positionSlot{
    position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/desktop/PositionedItemsContainer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".PositionedItemsContainer{\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.PositionedItemsContainer_positionSlot{\n    position: absolute;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
